<template>
  <div :class="$style.container">
    <div :class="$style.row">
      <span>{{ $t('common.discount') }}</span>
      <span>{{ formattedDiscountAmount }}</span>
    </div>
    <div :class="$style.row">
      <span>{{ promoCode }}</span>
      <span>{{ formattedDiscountValue }}</span>
    </div>
    <div :class="$style.row">
      <span>{{ $t('common.total') }}</span>
      <span>{{ formattedTotalAmount }}</span>
    </div>
  </div>
</template>

<script>
import { formatAmount } from 'lib/utils/amount';

export default {
  name: 'PromoCode',
  props: {
    content: {
      type: Object,
      reqiured: true,
    },
    currency: {
      type: Object,
      reqiured: true,
    },
  },
  computed: {
    promoCode() {
      return this.content.code;
    },
    formattedDiscountValue() {
      const { discountAmount, discountPercent } = this.content;

      if (this.$validate.isNull(discountAmount)) {
        return this.$t('discount.percent.on', { discountPercent });
      }

      return this.$t('discount.amount.on', {
        discountAmount: formatAmount(discountAmount, {
          significant_zeros: this.currency.significant_zeros,
          type: this.currency.type,
        }),
      });
    },
    formattedDiscountAmount() {
      return formatAmount(this.content.discountAmount, this.currency);
    },
    formattedTotalAmount() {
      return formatAmount(this.content.amountWithDiscount, this.currency);
    },
  },
};
</script>

<style lang="sass" module>
  .container
    padding: 8px
    font-weight: 400
    font-size: 12px
    line-height: 15px
    color: #212121
    border: 1px dashed #9B51E0
    border-radius: 8px

  .row
    display: flex
    justify-content: space-between

    &:not(:last-child)
      margin-bottom: 4px
</style>
